import { Box, Flex, Text, Th } from '@chakra-ui/react'
import { ArrowDown, ArrowUp } from 'phosphor-react'

import { SortDirection } from '../contexts/useSortableData'

export const SortableTh = ({
  children,
  sortKey,
  currentSortKey,
  sortDirection,
  onSort
}: {
  children: React.ReactNode
  sortKey: string
  currentSortKey: string | null
  sortDirection: SortDirection
  onSort: () => void
}) => {
  const isActive = currentSortKey === sortKey
  const direction = isActive ? sortDirection : null

  return (
    <Th fontSize="14px" onClick={onSort} cursor="pointer" role="group">
      <Flex gap={2}>
        <Text
          fontSize={'0.875rem'}
          color={'custom.gray.300'}
          fontWeight={'400'}
          textTransform={'lowercase'}
          _firstLetter={{
            textTransform: 'uppercase'
          }}
          letterSpacing={0}
        >
          {children}
        </Text>

        {direction === 'asc' && <ArrowUp />}
        {direction === 'desc' && <ArrowDown />}
        {direction === null && (
          <Box
            display="inline-flex"
            opacity={0}
            _groupHover={{ opacity: 0.9 }}
            transition="opacity 0.2s ease"
          >
            <ArrowUp />
          </Box>
        )}
      </Flex>
    </Th>
  )
}
